import { createSelector } from "reselect";

import getUserAgent from "./getUserAgent";

export default createSelector([getUserAgent], (userAgent) => {
  if (userAgent.source === "Mozilla/5.0 (Windows NT 10.0; Win64; x64)") {
    return 12;
  }

  // `userAgent.version` is `undefined` on iOS in the Facebook app. Allow this to return
  // `null`.
  if (!userAgent.version) {
    return null;
  }

  const [major, minor] = userAgent.version.split(".");
  return parseFloat(`${major}.${minor}`);
});
